import React from 'react';

export const ReloadUsersTableContext = React.createContext(() => {});
